// extracted by mini-css-extract-plugin
export var glossaryListFilter = "styles-module--glossaryListFilter--fb2e3";
export var termHeading = "styles-module--termHeading--04a82";